import {Injectable} from '@angular/core';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { AuthHttp } from '../core/auth-http.service';


@Injectable()
export class DetailsService {

constructor(private http: AuthHttp) {
}

getOfferDetails(id) {
return this.http.get('prd/travel/view/' + id)
.map((response: Response) => response.json());
}

}



// WEBPACK FOOTER //
// ./src/app/details/details.service.ts